import React from 'react'
import { connect } from 'react-redux'
import { CHANGE_TRANSLATIONS } from '../state/translations'
import { graphql } from 'gatsby'
import IndexPage from '../customPages/index'
class indexPageTemplate extends React.Component {
  constructor(props) {
    super(props)
    const lang = props.data.allSitePage.edges[0].node.context
    props.changeTranslations(lang)
  }

  render () {
    return (
      <>
        <IndexPage path={this.props.location.pathname} />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.translations.translations.home,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeTranslations: (payload) => dispatch(CHANGE_TRANSLATIONS(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(indexPageTemplate)

export const query = graphql`
  query($path: String!) {
    allSitePage(filter: {path: {eq: $path}}) {
      edges {
        node {
          context

        }
      }
    }
  }
`
